export function Logo({ className = 'h-[18px] w-[86px]' }: { className?: string }) {
  return <img src="/images/shared/nsave-logo.svg" alt="nsave" className={className} />;
}
